import React from "react";
import Home from "./home";

function Wheatley() {
    return (
        <>
            <Home/>
        </>
    )
}

export default Wheatley;